import api from '@/api'
import notifier from '@/notifier'

export default {
  namespaced: true,
  state: {
    attributes: [],
    fetching: false,
    removing: false,
    saving: false,
    total: 0
  },
  actions: {
    clearAttributes ({ state, commit, getters }) {
      commit('setFetchData', { items: [], total: 0 })
    },
    async fetchAttributes ({ state, commit, getters }, { identifier, options }) {
      commit('fetching', true)

      return api.getAttributes(identifier, options)
        .then(attributes => commit('setFetchData', attributes))
        .catch(() => commit('setFetchData', { items: [], total: 0 }))
        .finally(() => commit('fetching', false))
    },
    async saveAttribute ({ state, commit }, { attribute, identifier }) {
      commit('saving', true)

      if (attribute._id !== undefined) {
        attribute._id = attribute._id.$oid
      }

      return api.saveAttribute(attribute, identifier)
        .then(attribute => {
          commit('addAttribute', attribute)
          notifier.success('Atributo salvo com sucesso.', 'Sucesso')
        })
        .catch(() => notifier.error('Erro ao salvar o atributo.', 'Erro'))
        .finally(() => commit('saving', false))
    },
    async removeAttribute ({ state, commit }, { attribute, identifier }) {
      commit('removing', true)

      return api.removeAttribute(attribute._id.$oid, identifier)
        .then(() => {
          commit('removeAttribute', attribute._id.$oid)
          notifier.success('Atributo removido com sucesso.', 'Sucesso')
        })
        .catch(() => notifier.error('Erro ao remover atributo.', 'Erro'))
        .finally(() => { commit('removing', false) })
    },
    async retrieveAttribute ({ state, commit, getters }, { attributeId, identifier }) {
      commit('fetching', true)

      return api.getAttribute(identifier, attributeId)
        .then(attribute => commit('addAttribute', attribute))
        .catch(() => notifier.error('Erro ao buscar o atributo do marketplace.', 'Erro'))
        .finally(() => commit('fetching', false))
    }
  },
  getters: {
    getAttribute: state => attributeId => state.attributes.find(attribute => attribute._id.$oid === attributeId)
  },
  mutations: {
    addAttribute (state, attribute) {
      let isAttributeExists = false
      if (attribute._id !== undefined) {
        for (let i in state.attributes) {
          if (attribute._id.$oid === state.attributes[i]._id.$oid) {
            isAttributeExists = true
            state.attributes[i] = attribute
          }
        }
      }

      if (!isAttributeExists) {
        state.attributes.push(attribute)
        state.total += 1
      }
    },
    fetching (state, flag) {
      state.fetching = flag
    },
    saving (state, flag) {
      state.saving = flag
    },
    setFetchData (state, { total, items }) {
      state.total = total
      state.attributes = items
      state.fetching = false
    },
    removeAttribute (state, attributeId) {
      const attributes = []

      for (let i in state.attributes) {
        const attribute = state.attributes[i]

        if (attribute._id.$oid === attributeId) {
          continue
        }

        attributes.push(attribute)
      }

      state.attributes = attributes
    },
    removing (state, flag) {
      state.removing = flag
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/marketplaceAttribute.js